export function createPopupTemplate(layerTitle: string) {

    const popupTemplate = {
        title: layerTitle,
        content:  (feature: any) => {
            const attributes = feature.graphic.attributes;
            let contentHTML = `<table class="esri-widget__table" >`; 
            var colorIndex = true;
            for (const key in attributes) {
                if (attributes.hasOwnProperty(key)) {
                    const value = attributes[key];
                    if (colorIndex && value != null){
                        contentHTML += `<tr><td><div style= "text-align:center;">${key}</div></td class="esri-feature-fields__field-data"><td class="esri-feature-fields__field-data"><div style= "text-align:center;">${value}</div></td></tr>`;
                        colorIndex = false;
                    }
                    else if (value != null) {
                    contentHTML += `<tr><td class="esri-feature-fields__field-data"><div style= "text-align:center;">${key}</div></td class="esri-feature-fields__field-data"><td><div style= "text-align:center;">${value}</div></td></tr>`;
                    colorIndex = true;
                    }
                }
            }
            contentHTML += "</table>";
            return contentHTML;
        },
    };
    return popupTemplate;
}

